"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWidgetPanelStatusWithMirror = exports.getWidgetPanelsWithMirror = exports.getMirrorSnapshot = exports.getNodeParentFolderPermission = exports.getMirrorPermission = exports.getMirrorErrorCode = exports.getMirrorCollaborator = exports.getMirrorSourceInfo = exports.getMirrorLoading = exports.getMirrorNetworking = exports.getMirrorPack = exports.getMirror = void 0;
const datasheet_1 = require("../../../../../modules/database/store/selectors/resource/datasheet");
const getMirror = (state, mirrorId) => {
    var _a;
    mirrorId = mirrorId || state.pageParams.mirrorId;
    return (_a = state.mirrorMap[mirrorId]) === null || _a === void 0 ? void 0 : _a.mirror;
};
exports.getMirror = getMirror;
const getMirrorPack = (state, id) => {
    if (!id) {
        return;
    }
    return state.mirrorMap[id];
};
exports.getMirrorPack = getMirrorPack;
const getMirrorNetworking = (state, id) => {
    const datasheetPack = (0, exports.getMirrorPack)(state, id);
    if (!datasheetPack) {
        return;
    }
    return {
        loading: datasheetPack.loading,
        connected: datasheetPack.connected,
        syncing: datasheetPack.syncing,
        errorCode: datasheetPack.errorCode,
    };
};
exports.getMirrorNetworking = getMirrorNetworking;
const getMirrorLoading = (state, id) => {
    var _a;
    return (_a = (0, exports.getMirrorNetworking)(state, id)) === null || _a === void 0 ? void 0 : _a.loading;
};
exports.getMirrorLoading = getMirrorLoading;
const getMirrorSourceInfo = (state, id) => {
    const mirror = (0, exports.getMirror)(state, id);
    return mirror === null || mirror === void 0 ? void 0 : mirror.sourceInfo;
};
exports.getMirrorSourceInfo = getMirrorSourceInfo;
const getMirrorCollaborator = (state, id) => {
    const mirrorPack = (0, exports.getMirrorPack)(state, id);
    return mirrorPack === null || mirrorPack === void 0 ? void 0 : mirrorPack.client.collaborators;
};
exports.getMirrorCollaborator = getMirrorCollaborator;
const getMirrorErrorCode = (state, id) => {
    const mirrorPack = (0, exports.getMirrorPack)(state, id);
    return mirrorPack === null || mirrorPack === void 0 ? void 0 : mirrorPack.errorCode;
};
exports.getMirrorErrorCode = getMirrorErrorCode;
const getMirrorPermission = (state, id) => {
    const mirror = (0, exports.getMirror)(state, id);
    return mirror.permissions;
};
exports.getMirrorPermission = getMirrorPermission;
const getNodeParentFolderPermission = (state) => {
    var _a;
    const folderId = (0, datasheet_1.getDatasheetParentId)(state);
    return ((_a = state.catalogTree.treeNodesMap[folderId]) === null || _a === void 0 ? void 0 : _a.permissions) || {};
};
exports.getNodeParentFolderPermission = getNodeParentFolderPermission;
const getMirrorSnapshot = (state, id) => {
    const mirror = (0, exports.getMirror)(state, id);
    return mirror.snapshot;
};
exports.getMirrorSnapshot = getMirrorSnapshot;
const getWidgetPanelsWithMirror = (state, mirrorId) => {
    const snapshot = (0, exports.getMirrorSnapshot)(state, mirrorId);
    return snapshot && snapshot.widgetPanels;
};
exports.getWidgetPanelsWithMirror = getWidgetPanelsWithMirror;
const getWidgetPanelStatusWithMirror = (state, mirrorId) => {
    var _a;
    const mirrorPack = (0, exports.getMirrorPack)(state, mirrorId);
    return (_a = mirrorPack === null || mirrorPack === void 0 ? void 0 : mirrorPack.client) === null || _a === void 0 ? void 0 : _a.widgetPanelStatus;
};
exports.getWidgetPanelStatusWithMirror = getWidgetPanelStatusWithMirror;
//# sourceMappingURL=mirror.js.map